import api from "@/services/api";

/**
 * @description Servicio para interactuar con el endpoint /urgency-providers.
 * Gestiona la asignación y desactivación de médicos prestadores de urgencia.
 */
const urgencyProviderService = {};

const endpoint = "/urgency-providers";

/**
 * @description Obtiene todos los prestadores de urgencia con filtros opcionales
 * @param {Object} [params] - Parámetros de filtro
 * @param {string} [params.medicalSpecialtyId] - Filtrar por especialidad
 * @param {boolean} [params.isActive] - Filtrar por estado activo/inactivo
 * @returns {Promise<Array>} Lista de prestadores
 */
urgencyProviderService.getAll = function (params) {
  return api.get(endpoint, { params }).then((r) => r.data);
};

/**
 * @description Asigna un médico como prestador de urgencia para una especialidad
 * @param {Object} data - Datos de asignación
 * @param {string} data.doctorId - ID del médico a asignar
 * @param {string} data.medicalSpecialtyId - ID de la especialidad de urgencia
 * @returns {Promise<Object>} Prestador creado
 */
urgencyProviderService.assign = function ({ doctorId, medicalSpecialtyId }) {
  return api
    .post(endpoint, { doctorId, medicalSpecialtyId })
    .then((r) => r.data);
};

/**
 * @description Desactiva un prestador de urgencia
 * @param {string} providerId - ID del prestador a desactivar
 * @returns {Promise<Object>} Prestador desactivado
 */
urgencyProviderService.deactivate = function (providerId) {
  return api.put(`${endpoint}/${providerId}/deactivate`).then((r) => r.data);
};

/**
 * @description Obtiene la asignación de urgencia del usuario actual
 * @returns {Promise<Object|null>} Asignación del usuario o null
 */
urgencyProviderService.getMyAssignment = function () {
  return api.get(`${endpoint}/me`).then((r) => r.data);
};

export default urgencyProviderService;
